export enum Languages {
  EN = 'EN',
  RU = 'RU',
}

export const languageList: Languages[] = Object.values(Languages);
